export const getLogoByDomain = () => {
    const domainLogoMapping = {
        'ag.aura444.us': '/logos/logo.png',
        'ag.aura444.me': '/logos/aura444.png',
        'ag.master444.bet': '/logos/master444.png',
        'ag.ptsexch.in': '/logos/ptsexch.png',
        'ag.aura-444.com': '/logos/logo.png',
    };

    // Get the current domain
    const currentDomain = window.location.hostname;

    // Return the corresponding logo or a default one
    return domainLogoMapping[currentDomain] || '/logos/logo.png';
};
